<template>
  <div class="food-result edit-dialog">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item>
          <md-icon
            slot="default"
            style="float:right;cursor:pointer"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-paper style="position: relative; z-index: 99">
      <mu-list>
        <mu-list-item disableRipple :describeText="food.brand_name">
          <div slot="title">
            <span v-text="isLoading ? $t('message.loadingText') : food.food_name"></span>
          </div>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <div class="scrollable-area">
      <mu-row gutter v-if="!isLoading">
        <mu-col width="100" :desktop="leftPaneWidth.desktop" :tablet="leftPaneWidth.tablet" class="bottom">
          <mu-content-block style="padding: 16px 24px;">
            <mu-row gutter style="margin-bottom: 8px">
              <mu-col width="50" :desktop="servingPickerWidth.servingInput.desktop"
                      :tablet="servingPickerWidth.servingInput.tablet"
              >
                <mu-text-field
                  v-validate="'required|min_value:0|max_value:99'"
                  data-vv-name="serving_size"
                  :data-vv-as="$t('message.labelServingSize')"
                  :errorText="errors.first('serving_size')"
                  v-model.number="model.servings"
                  :min="0"
                  type="number"
                  :hintText="$t('message.labelMultiplier')"
                  :label="$t('message.labelServingSize')"
                  fullWidth
                ></mu-text-field>
              </mu-col>
              <mu-col
                width="50"
                :desktop="servingPickerWidth.servingSelector.desktop"
                :tablet="servingPickerWidth.servingSelector.tablet"
              >
                <mu-select-field
                  :scroller="scroller"
                  :maxHeight="248"
                  label=" "
                  v-model.number="model.serving_id"
                  fullWidth
                  autoWidth>
                  <mu-menu-item
                    v-for="serving, index in food.servings"
                    :key="'serving-' + index"
                    :value="serving.serving_id"
                    :title="serving.serving_description"
                  ></mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>

            <mu-row style="margin-bottom: 8px;">
              <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                      :tablet="servingPickerWidth.servingInput.tablet">
                <span>
                  <mu-flexbox align="center" style="height: 34px;">
                    <mu-flexbox-item style="font-weight: 500"
                                     v-text="$t('message.foodDiaryQuickPortionLabel')"></mu-flexbox-item>
                  </mu-flexbox>
                </span>
              </mu-col>
              <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                      :tablet="servingPickerWidth.servingSelector.tablet">
                 <span>
                  <mu-chip @click.native="setServingSize('0.25')">1/4</mu-chip>
                  <mu-chip @click.native="setServingSize('0.5')">1/2</mu-chip>
                  <mu-chip @click.native="setServingSize('0.75')">3/4</mu-chip>
                  <mu-chip @click.native="setServingSize('1')">1</mu-chip>
                </span>
              </mu-col>
            </mu-row>

            <mu-row gutter>
              <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                      :tablet="servingPickerWidth.servingInput.tablet">
                <mu-time-picker
                  container="inline"
                  :label="$t('message.labelTime')"
                  mode="landscape"
                  fullWidth
                  v-model="timeModel.time"
                  :okLabel="$t('message.okText')"
                  :cancelLabel="$t('message.cancelText')"></mu-time-picker>
              </mu-col>
              <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                      :tablet="servingPickerWidth.servingSelector.tablet">
                <mu-date-picker
                  container="inline"
                  :label="$t('message.labelDate')"
                  :okLabel="$t('message.okText')"
                  :cancelLabel="$t('message.cancelText')"
                  :dateTimeFormat="dateFormat"
                  format="DD-MM-YYYY"
                  v-model="timeModel.date"
                  :maxDate="maxDate"
                  fullWidth></mu-date-picker>
              </mu-col>
            </mu-row>
          </mu-content-block>
        </mu-col>
        <mu-col width="100" desktop="50" tablet="50" class="rightPane" v-if="isNutritionPaneVisible">
          <mu-card-header
            class="removePadding"
            :subTitle=" model.servings + ' x ' + activeServingObject.serving_description"
          ></mu-card-header>
          <mu-divider></mu-divider>
          <mu-list class="oddEven">
            <mu-list-item
              disableRipple
              v-for="(value, key) in activeServingObject.nutrients"
              :key="'nutrient-'+ key"
              :title="$t(localizeNutrient(key))"
              :afterText="'' + rounded(value * model.servings) + getUnit(key)"
            >
            </mu-list-item>
          </mu-list>
        </mu-col>
      </mu-row>
    </div>
    <mu-card-actions class="card-actions" align="right" v-show="!isLoading">
      <mu-flat-button
        :label="$t('message.cancelText')"
        @click="closeDialog('addFoodDialog')"
      ></mu-flat-button>
      <mu-raised-button
        :disabled="isSaving"
        :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
        @click.native="updateFood()"
        secondary
      ></mu-raised-button>
    </mu-card-actions>
  </div>
</template>
<script>

  
  import FoodApi from '../../../api/Food'
  
  import config from '../../../config';
  import dateFormat from '../../../helpers/DatePickerManager'
  import FoodDiaryNutritionMixin from '../../../mixins/FoodDiaryNutritionMixin'
  import NutrientLocalizerMixin from '../../../mixins/Localization/FoodNutrients/NutrientLocalizer'

  let numeral = require('numeral');


  const leftPaneWidth = {
    desktop: "50",
    tablet: "50"
  };

  const servingPickerWidth = {
    servingInput: {
      desktop: "40",
      tablet: "40"
    },
    servingSelector: {
      desktop: "60",
      tablet: "60"
    }
  };

  export default {
    name: 'fd-edit-food-dialog',
    mixins: [FoodDiaryNutritionMixin, NutrientLocalizerMixin],
    props: {
      title: {
        type: String,
        default: "Edit"
      },
      foodObj: {
        type: Object
      },
      mealTypeId: {
        type: Number
      }
    },
    watch: {
      'timeModel.time': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'timeModel.date': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'model.serving_id': function () {
        let self = this, serving_id = self.model.serving_id;
        self.activeServingObject = self.food.servings.filter(function (item) {
          return item.serving_id === self.model.serving_id;
        })[0];
        self.computeHeightForRightPane();
      }
    },
    data() {
      return {
        maxDate: moment().format('DD-MM-YYYY'),
        dateFormat: dateFormat,
        date: new Date(),
        isSaving: false,
        isLoading: true,
        isNutritionPaneVisible: true,
        scroller: document.getElementsByClassName('main-content')[0],
        activeServingObject: {},
        food: {},
        leftPaneWidth: leftPaneWidth,
        servingPickerWidth: servingPickerWidth,
        timeModel: {
          date: "",
          time: ""
        },
        model: {
          date: "",
          servings: 1,
          serving_id: 1
        }
      }
    },
    mounted() {
      let self = this;

      let date = moment(self.foodObj.date_created), time = date.format('hh:mm a');
      self.timeModel.time = time;
      self.timeModel.date = date.format('DD-MM-YYYY');

      FoodApi.getById(self.foodObj.fs_food_id)
        .then(function (response) {
          self.food = response.data.food;
          self.model.serving_id = self.foodObj.fs_serving_id;
          self.model.servings = self.foodObj.servings;
          self.isLoading = false;
          self.$nextTick(function () {
            self.initScrollFix();
            self.computeHeightForRightPane();
          });
        });
    },
    methods: {
      isDst(now) {
        if (moment(now).isDST()) {
          return true;
        }
        return false;
      },
      setServingSize(size) {
        let self = this;
        self.model.servings = size;
        self.$forceUpdate();
      },
      updateFood() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              let model = {
                date: self.model.date,
                food_id: self.foodObj.food_id,
                food_name: self.food.food_name,
                servings: self.model.servings,
                serving_id: self.model.serving_id,
                nutrients: self.activeServingObject.nutrients
              };
              FoodApi.updateFood(model)
                .then(function (response) {
                  self.$emit('foodUpdated');
                  self.closeDialog('addFoodDialog');
                })
            }
          });
      },
      toggleNutritionPane() {
        let self = this;
        self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
        if (self.isNutritionPaneVisible !== true) {
          self.leftPaneWidth.tablet = "100";
          self.leftPaneWidth.desktop = "100";
          self.servingPickerWidth.servingInput.desktop = "20";
          self.servingPickerWidth.servingInput.tablet = "20";
          self.servingPickerWidth.servingSelector.desktop = "80";
          self.servingPickerWidth.servingSelector.tablet = "80";
        }
        else {
          self.leftPaneWidth.tablet = "50";
          self.leftPaneWidth.desktop = "50";
          self.servingPickerWidth.servingInput.desktop = "40";
          self.servingPickerWidth.servingInput.tablet = "40";
          self.servingPickerWidth.servingSelector.desktop = "60";
          self.servingPickerWidth.servingSelector.tablet = "60";
        }
        self.$nextTick(function () {
          self.computeHeightForRightPane();
        });
      },
      rounded(num) {
        let number = numeral(num.toFixed(2));
        return number.format('0,0.0')
      },
      initScrollFix() {
        let headerHeight = $('.food-result .blueHeader').outerHeight(true);
        let displayBar = $('.food-result .mu-paper').outerHeight(true);
        let panelHeight = $('.add-food-dialog').outerHeight(true);
        let cardActionsHeight = $('.card-actions').outerHeight(true);
        let scrollHeight = panelHeight - (headerHeight + displayBar + cardActionsHeight);
        $('.food-dialog-container .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
      },
      computeHeightForRightPane() {
        let scrollHeight = $('.food-result .scrollable-area').outerHeight(true);
        $('.rightPane').attr('style', 'height:' + scrollHeight + 'px;overflow:auto');
      },
      userDecidesTo(option) {
        this.$emit('choseToSearchWith', option);
      },
      closeDialog(ref) {
        this.$emit('closeDialog', ref)
      }
    }
  }
</script>
<style>
  .danger {
    background: #e74c3c;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// FoodEditDialog.vue?30486cc7